import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseCursus } from '../base-cursus';
import { GenericData, Cycle, CycleYear, CycleMonth, eItem, CycleModel, SessionItem } from '../../shared';
import { PathName } from '../../shared/path.model';
import { EndWithSlash } from 'projects/lib-components/src/public_api';

@Component({
  selector: 'webstore-cyclelist',
  templateUrl: './cyclelist.component.html',
  styleUrls: ['./cyclelist.component.css']
})

export class CycleListComponent extends BaseCursus implements OnInit {

  public cycles: GenericData<Cycle>[] = [];
  public cyclesFiltered: GenericData<Cycle>[] = [];
  public yearList: CycleYear[] = [];
  public MonthsList: CycleMonth[] = [];
  public nbCycle: number;

  constructor(
    public store: StoreService,
    protected http: HttpClient,
    protected router: Router
  ) {
    super(store);
  }

  ngOnInit(): void {

    this.store.showSplash(true);

    const childStage: SessionItem | null = super.getSession(eItem.STAGE);
    const IdStage: string = (childStage && childStage.id && childStage.id !== '') ? childStage.id : '0';
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/cycle/getData/V2/INITDATA/${IdStage}`;
    this.http.get<CycleModel>(destUrl).subscribe((data: CycleModel): void => {
      if (!data.HasError) {
        this.yearList = data.CycleYearsList;
        this.MonthsList = data.CycleMonthsList;
        this.cycles = this.store.convertList<Cycle>(data.CycleList, 2);
        this.cyclesFiltered = this.cycles;
        this.nbCycle = data.CycleList.length;
      }
      this.store.showSplash(false);
    }, (error: any): void => { JSON.stringify(error); });
  }

  selectCycle(ccl: Cycle): void {
    this.store.PathItem.SetPathItem(PathName.CYCLE, ccl.Ident, ccl);

    super.setCycle(ccl);
    this.router.navigate([this.store.AppRoutes.CYCLEDETAILS]);
  }

  getAllCycles(): void {
    this.cyclesFiltered = this.cycles;
  }

  filterCycles(year: number, month: number): void {
    this.cyclesFiltered = super.filterCursus(this.cycles, year, month);
  }

}
